import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function RequireRole({ roles = ["admin"], children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-mm-bg">
                <Loader2 className="animate-spin text-mm-navy" size={28} />
            </div>
        );
    }
    if (!user) {
        return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
    }
    if (!roles.includes(user.role)) {
        return <Navigate to="/admin/not-authorized" replace />;
    }
    return children;
}
